<!-- Blank Mega Menu Component -->
<script setup lang="ts">

import { vwWithMax } from '~/utility/utility';

const defultWidth = computed(() => {
  // During SSR, return a consistent fallback value to prevent hydration mismatches
  if (typeof window === 'undefined') {
    return '1300px' // Use max width during SSR for consistency
  }
  return vwWithMax(80, 1300) + "px"
});
</script>

<template>
  <Frame id="mega-media" class="io-mega-popover sec-popover-container popover-media mega-products">
    <Frame class="sec-mega-container" w="grid grid-cols-[360px_1fr] g-0">
      <Frame class="column col-navigation" w="gp-1">
        <!-- Navigation content goes here -->
      </Frame>
      <Frame class="column col-content" w="h-full gpt-1">
        <!-- Main content goes here -->
      </Frame>
    </Frame>
  </Frame>
</template>

<style lang="scss" scoped>

#mega-media {
  width: v-bind(defultWidth);
}

.mega-media {
  .sec-mega-container {
    padding: gr(1);
  }
}
</style>